// extracted by mini-css-extract-plugin
export var bubble = "bubble-module--bubble--8BlS1";
export var cr = "bubble-module--cr--h0xQs";
export var cl = "bubble-module--cl--yqi4u";